import api, { transformRequest, transformResponse } from "services/api";

export const lookupApi = api.enhanceEndpoints({ addTagTypes: [] }).injectEndpoints({
  endpoints: (build) => ({
    payAch: build.mutation({
      query: (payload) => ({
        url: `api/v1/consumer/pay/ach/`,
        method: "POST",
        body: transformRequest(payload),
      }),
      transformResponse: (response) => transformResponse(response),
    }),
    payCard: build.mutation({
      query: (payload) => ({
        url: `api/v1/consumer/pay/card/`,
        method: "POST",
        body: transformRequest(payload),
      }),
      transformResponse: (response) => transformResponse(response),
    }),
    // AKT-8286: the creditor's minimum payment amount, resolved per account, so the
    // amount field can enforce it before the consumer submits.
    getAccountPaymentRules: build.query({
      query: (payload) => ({
        url: `api/v1/consumer/payment-rules/`,
        method: "POST",
        body: transformRequest(payload),
      }),
      transformResponse: (response) => transformResponse(response),
    }),
  }),
});

export const { useGetAccountPaymentRulesQuery, usePayAchMutation, usePayCardMutation } = lookupApi;
